var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0095DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.19 6H11.82C8.18002 6 6.01001 8.17 6.01001 11.81V20.18C6.01001 23.82 8.18002 25.99 11.82 25.99H20.19C23.83 25.99 26 23.82 26 20.18V11.81C26 8.17 23.83 6 20.19 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.18 20.77C12.16 20.77 12.13 20.77 12.11 20.77C11.14 20.68 10.23 20.23 9.54998 19.51C7.94998 17.83 7.94998 15.1 9.54998 13.42L11.74 11.12C12.52 10.3 13.57 9.83997 14.69 9.83997C15.81 9.83997 16.86 10.29 17.64 11.12C19.24 12.8 19.24 15.53 17.64 17.21L16.55 18.36C16.26 18.66 15.79 18.67 15.49 18.39C15.19 18.1 15.18 17.63 15.46 17.33L16.55 16.18C17.61 15.07 17.61 13.26 16.55 12.16C15.56 11.12 13.82 11.12 12.82 12.16L10.63 14.46C9.56998 15.57 9.56998 17.38 10.63 18.48C11.06 18.94 11.64 19.22 12.25 19.28C12.66 19.32 12.96 19.69 12.92 20.1C12.89 20.48 12.56 20.77 12.18 20.77Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.31 22.1599C16.19 22.1599 15.14 21.7099 14.36 20.8799C12.76 19.1999 12.76 16.4699 14.36 14.7899L15.45 13.6399C15.74 13.3399 16.21 13.3299 16.51 13.6099C16.81 13.8999 16.82 14.3699 16.54 14.6699L15.45 15.8199C14.39 16.9299 14.39 18.7399 15.45 19.8399C16.44 20.8799 18.18 20.8899 19.18 19.8399L21.37 17.5399C22.43 16.4299 22.43 14.6199 21.37 13.5199C20.94 13.0599 20.36 12.7799 19.75 12.7199C19.34 12.6799 19.04 12.3099 19.08 11.8999C19.12 11.4899 19.48 11.1799 19.9 11.2299C20.87 11.3299 21.78 11.7699 22.46 12.4899C24.06 14.1699 24.06 16.8999 22.46 18.5799L20.27 20.8799C19.48 21.7099 18.43 22.1599 17.31 22.1599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUserPlus);
export default __webpack_public_path__ + "static/media/u_user-plus.c4a69efc65836d263912647546f93981.svg";
export { ForwardRef as ReactComponent };